import React from 'react'
import PropTypes from "prop-types"
import { get, sortBy, values } from 'lodash'
import { Panel, Glyphicon, Table, Modal, ButtonGroup, Checkbox } from 'react-bootstrap'
import moment from "moment"
import Button from '../../components/Button.jsx'
import MarkdownField from '../../lib/MarkdownField'
import FormatHelpModal from './FormatHelpModal'
import EditScheduleModal from './EditScheduleModal'
import DeleteModal from './DeleteModal'
import AddScheduleModal from './AddScheduleModal'

import {
  timetablePropType, 
  schedulePropType,
  editScheduleNote,
  makeSchedulesTimes,
  editDaySchedule,
  editDayOpen,
  editAllDaySchedule,
  deleteAny,
} from '../timetable'

const weekdays = ["Domingo", "Lunes", "Martes", "Miercoles", "Jueves", "Viernes", "Sabado"]

const regexHour = '\\d\\d\\:\\d\\d'
const regexRange = `${regexHour}\\-${regexHour}`

const regularRegex = string => new RegExp(`^\\s*${regexHour}(\\s*\n+${regexHour})*\n*$`, "g").test(string)
const allDayRegex = string => new RegExp(`^\\s*${regexRange}(\\s*\n+${regexRange})*\n*$`, "g").test(string)

export default class SchedulesEditor extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      formatHelpModal: false,
      startedNotes: {}
    }
  }

  startNote(key) {
    this.setState({ startedNotes: { ...this.state.startedNotes, [key]: true } })
  }

  componentDidMount() {
    const initialState = {}
    values(this.props.timetable.schedules)
      .filter(sch => sch.key)
      .forEach(schedule  => {
        initialState[schedule.key] = makeSchedulesTimes(this.props.timetable, schedule)
      })
    this.setState(initialState)
  }

  getScheduleColor(schedule, i) {
    if (!get(this.state, [schedule.key, i, 'value'])) return "darkgrey"
    else if (get(this.state, [schedule.key, i, 'regexp'])) return "darkgrey"
    else return "red"
  }

  editDayScheduleOnChange(schedule, i, evt) {
    const regexp = new RegExp(`^\\s*${regexHour}(\\s*\n+${regexHour})*\n*$`, "g").test(evt.target.value)
    this.setState({
      [schedule.key]: {
        ...(this.state[schedule.key]),
        [i]: { ...this.state[schedule.key][i], times: evt.target.value, regexp }
      }
    })
    if (regexp || evt.target.value == "") {
      this.props.onChange(
        editDaySchedule(this.props.timetable, schedule.key, i, evt.target.value)
      )
    }
  }

  editAllDayScheduleOnChange(schedule, i, evt) {
    const regexp = new RegExp(`^\\s*${regexRange}(\\s*\n+${regexRange})*\n*$`, "g").test(evt.target.value)
    this.setState({
      [schedule.key]: {
        ...(this.state[schedule.key]),
        [i]: { ...this.state[schedule.key][i], allDayTimes: evt.target.value, regexp }
      }
    })
    if (regexp || evt.target.value == "") {
      this.props.onChange(
        editAllDaySchedule(this.props.timetable, schedule.key, i, evt.target.value)
      )
    }
  }

  getScheduleText(schedule, i, scheduleHours) {
    if (!get(this.state, [schedule.key, i, 'isOpen'], false)) return <span style={{ color: "darkgrey", marginTop: '5px' }}>Cierra</span>
    else if ((this.props.timetable.allDay && allDayRegex(scheduleHours)) || (!this.props.timetable.allDay && regularRegex(scheduleHours))) return null
    else return (
      <span style={{ color: "red", marginTop: '5px' }}>
        Error
        <Button
          bsSize="xsmall"
          style={{ borderRadius: "50%", marginLeft: 4 }}
          glyph="question-sign"
          tooltipText="Ayuda"
          onClick={() => this.setState({ formatHelpModal: true })}
        />
      </span>
    )
  }

  render() {
    const { timetable, onChange } = this.props
    return (
      <React.Fragment>
        {sortBy(
          values(timetable.schedules).filter(sch => sch.key),
          ['startDate']
        )
          .map(schedule => (
            <Panel bsStyle="info" key={schedule.key} className="schedule-panel">
              <Panel.Heading style={{ position: 'relative' }}>
                <Panel.Title>
                  <span>{moment(schedule.startDate).format("LL")}</span>
                  <Glyphicon glyph="arrow-right" />
                  <span>{moment(schedule.endDate).format("LL")}</span>
                </Panel.Title>
                <ButtonGroup>
                  <Button
                    tooltipText="Editar" bsSize="xsmall" glyph="pencil"
                    onClick={() => this.setState({ showEditScheduleModal: true, scheduleToEdit: schedule })}
                  />
                  <Button
                    tooltipText="Eliminar" bsSize="xsmall" bsStyle="danger" glyph="trash"
                    onClick={() => this.setState({ deleteModal: true, itemToDelete: schedule.key })}
                  />
                </ButtonGroup>
              </Panel.Heading>
              <Panel.Body>
                <Table
                  className={`times-table`}
                  bordered condensed
                >
                  <thead>
                    <tr>
                      {[1, 2, 3, 4, 5, 6, 0].map(i => (
                        <th 
                          key={i}
                        >
                          <div>
                            <span>{weekdays[i]}</span>
                            <Checkbox
                              className="open-checkbox"
                              checked={get(this.state, [schedule.key, i, 'isOpen'], false)}
                              onChange={evt => {
                                this.setState({
                                  [schedule.key]: {
                                    ...(this.state[schedule.key]),
                                    [i]: { ...this.state[schedule.key][i], isOpen: evt.target.checked }
                                  }
                                })
                                onChange(editDayOpen(timetable, schedule.key, i, evt.target.checked))
                              }}
                            />
                          </div>
                          
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      {
                        [1, 2, 3, 4, 5, 6, 0].map(i => {
                          const scheduleHours = timetable.allDay ? get(this.state, [schedule.key, i, 'allDayTimes'], "") : get(this.state, [schedule.key, i, 'times'], "")
                          return (
                            <td key={i} className={get(this.state, [schedule.key, i, 'isOpen'], false) ? "open" : "closed"}>
                              {
                                <React.Fragment>
                                
                                  <textarea
                                    disabled={!get(this.state, [schedule.key, i, 'isOpen'], false)}
                                    className="schedule-textarea"
                                    style={{ borderColor: this.getScheduleColor(schedule, i) }}
                                    value={scheduleHours}
                                    onChange={evt => (timetable.allDay 
                                      ? this.editAllDayScheduleOnChange(schedule, i, evt)
                                      : this.editDayScheduleOnChange(schedule, i, evt)
                                    )
                                    }
                                  />
                                  <div style={{ width: "100%" }}>
                                    {this.getScheduleText(schedule, i, scheduleHours)}
                                  </div>
                                </React.Fragment>
                              }

                            </td>
                          )
                        })
                      }
                    </tr>
                  </tbody>
                </Table>
                {
                  // #TODO this behaviour (add note, then field appears) is cool af, very clear. generalize and reuse it!
                  (schedule.note || this.state.startedNotes[schedule.key])
                    ? (
                      <MarkdownField
                        className="note-field"
                        onChange={x => onChange(editScheduleNote(timetable, schedule.key, x))}
                        value={schedule.note}
                        label={(<span>Nota</span>)}
                        forceOpen={this.state.startedNotes[schedule.key]}
                      />
                    )
                    : (
                      <React.Fragment>
                        <label style={{ marginRight: 10, marginTop: 5 }}>Nota</label>
                        <Button
                          bsSize="xsmall" glyph="plus-sign" tooltipText="Añadir nota"
                          onClick={this.startNote.bind(this, schedule.key)}
                        />
                      </React.Fragment>
                    )
                }
              </Panel.Body>
            </Panel>
          ))}
        <Button
          glyph="plus" label="Añadir horario" bsStyle="primary"
          style={{ marginBottom: 10 }}
          onClick={() => this.setState({ showAddScheduleModal: true })}
        />
        {
          this.state.showAddScheduleModal && (
            <AddScheduleModal
              timetable={timetable}
              onClose={() => this.setState({ showAddScheduleModal: false })}
              onChange={changes => {
                this.setState({ showAddScheduleModal: false, [changes.schedule.key]: makeSchedulesTimes(timetable, changes.schedule) })
                onChange(changes.timetable)
              }}
            />
          )
        }
        {
          this.state.showEditScheduleModal && (
            <EditScheduleModal
              timetable={timetable}
              schedule={this.state.scheduleToEdit}
              onClose={() => this.setState({ showEditScheduleModal: false })}
              onChange={tt => {
                this.setState({ showEditScheduleModal: false })
                onChange(tt)
              }}
            />
          )
        }
        {
          this.state.deleteModal && (
            <DeleteModal
              item={this.state.itemToDelete}
              onClose={() => this.setState({ deleteModal: false })}
              onDelete={() => {
                onChange(deleteAny(timetable, this.state.itemToDelete))
                this.setState({ deleteModal: false })
              }}
            />
          )
        }
        {
          this.state.formatHelpModal && (
            <FormatHelpModal
              isAllDay={timetable.allDay}
              onClose={() => this.setState({ formatHelpModal: false })}
            />
          )
        }
      </React.Fragment>
    )
  }
}

SchedulesEditor.propTypes = {
  timetable: timetablePropType.isRequired,
  onChange: PropTypes.func.isRequired,
}